import { FC } from 'react';
import { FormProvider } from 'react-hook-form';
import { StopWithDetails } from '../../../../../types';
import { StopVersionForm } from './StopVersionForm';
import { CreateStopVersionResult, ExistingStopValidityRange } from './Types';
import { useCopyStopFormUtils } from './Utils';

type CopyStopFormProps = {
  readonly className?: string;
  readonly existingValidityRanges: ReadonlyArray<ExistingStopValidityRange>;
  readonly onCancel: () => void;
  readonly onCopyCreated: (result: CreateStopVersionResult) => void;
  readonly originalStop: StopWithDetails;
};

export const CopyStopForm: FC<CopyStopFormProps> = ({
  className,
  existingValidityRanges,
  onCancel,
  onCopyCreated,
  originalStop,
}) => {
  const { methods, onFormSubmit } = useCopyStopFormUtils(
    originalStop,
    onCopyCreated,
  );

  return (
    <FormProvider {...methods}>
      <StopVersionForm
        className={className}
        existingValidityRanges={existingValidityRanges}
        onCancel={onCancel}
        onSubmit={methods.handleSubmit(onFormSubmit)}
      />
    </FormProvider>
  );
};
